import React, { useState, useEffect } from "react";
import billImg from "../../images/bill.png";
import SearchIcon from "@mui/icons-material/Search";
import ClipLoader from "react-spinners/ClipLoader";
import { useHistory } from "react-router-dom";
import whatsAppIcon from "../../images/whatsAppIcon.png";
import { RepositoryFactory } from "../../Repository/RepositoryFactory";
import moment from "moment";
const BillsRepository = RepositoryFactory.get("bills_repository");
import BillPreview from "../reusableComponents/BillPreview";
import InfiniteScroll from "react-infinite-scroll-component";
import {
  deleteBill,
  getBills,
  getOutstandings,
  getSearchBills,
  deleteInCashInHand,
  deleteInBank
} from "./httpCalls";
import { styled } from "@mui/system";
import { Box, Button, Stack, Typography, Grid, TextField,Checkbox,FormControlLabel } from "@mui/material";
import dustbin from "../../images/dustbin.png";
import DeleteBill from "../reusableComponents/DeleteBill";
import {  IconBox, TitleBox } from "./styles";
import UpdateBillDate from "./UpdateBillDate";
import { useDispatch, useSelector } from "react-redux";
import { getTrial } from "../../pages/trial/trialSlice";
import BillPreviewUpdated from "../reusableComponents/BillPreview/BillPreviewUpdated";
import { useMediaQuery, useTheme } from '@mui/material';
import { Menu, MenuItem, Select , FormControl, InputLabel, } from '@mui/material';
import Repo from "../../Repository/Repo";
import { saveBillToIndexedDB, getBillsFromIndexedDB, deleteBillFromIndexedDB } from '../point of sale/IndexDb';
import { getBillNumber } from "../point of sale/httpCalls";

const SearchField = styled(Box)({
  display: "flex",
  backgroundColor: "white",
  borderRadius: "5px",
  boxShadow: "0px 2px 5px #c2c1c1",
  justifyContent: "space-between",
  marginTop: "20px",
});
const BillContainer = styled("div")({
  position: "relative",
  display: "grid",
  gridTemplateColumns: "34% 17% 27% 21%",
  backgroundColor: "white",
  boxShadow: "0px 3px 6px #c2c1c1",
  padding: "10px",
  margin: "2px",
  marginBottom: "5px",
  borderRadius: "5px",
});
const Title = styled(Typography)({
  width: "80%",
  textAlign: "center",
  margin: "20px auto",
  color: "#4daf51",
});

const ButtonClear = styled(Button)({
  marginTop: "22px",
  backgroundColor: "white",
  padding: "7px 0px",
  color: "black",
  "&:hover": {
    backgroundColor: "white",
  },
});
const DateField = styled(TextField)({
  backgroundColor: "white",
  borderRadius: "5px",
  boxShadow: "0px 2px 5px #c2c1c1",
});



function Bills() {
  const dispatch = useDispatch();
  const { expiryDate, status, loading } = useSelector((state) => state.trial);
  const theme = useTheme();
  const isMdDown = useMediaQuery(theme.breakpoints.down('sm'));

  const [billsData, setBillsData] = useState([]);
  const history = useHistory();
  const [state, setState] = useState({
    loading: false,
    showBill: false,
    search: "",
    startDate: "",
    endDate: "",
    noBills: "",
    profit:false,
    bill: {
      items: [],
    },
    bills: [],
    outstandingBills: [],
    next_page_token: "",
    current_page_token: "",
    hasMore: true,
    nextPageToken: "",
    currentPageToken: "",
    more: true,
    deleteModal: false,
    selectedBill: {},
  });
  const [open, setOpen] = useState(false);
  const [selectedBill, setSelectedBill] = useState({});
  const companyCode = localStorage.getItem("companyCode");
  const [billStatus, setBillStatus] = useState('');
  const [billNumber, setbillNumber] = useState(0);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
 const [isOfflineBills, setIsOfflineBills] = useState([]);
 const templateType = localStorage.getItem("template");
console.log('stateee', state.selectedBill)
  useEffect(() => {
    getAllBills();
  }, []);

  const BillBox = styled(Grid)(({ theme }) => ({
    backgroundColor: "white",
    boxShadow: "0px 3px 6px #c2c1c1",
    padding: "4px",
    margin: "2px",
    marginBottom: "5px",
    borderRadius: "5px",
    height: state.profit ? "160px" :  "115px",
     display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("lg")]: {
      height: state.profit ? "160px":   "120px",
      paddingLeft: "10px",
    },
    [theme.breakpoints.down("md")]: {
      height: state.profit ? "160px" :  "200px",
      paddingLeft: "10px",
    },
  }));


  useEffect(() => {
    if(isOnline == true) {

    getBill();


          
  }
  }, []);

  useEffect(()=> {
    if( isOnline == true) {
      getBillsFromIndexedDB()
      .then(billsarray => {
          console.log('Bills:', billsarray);
        // const offlineBills=  billsarray.map((billslocal)=> {
        //     console.log('billlocal', billslocal)
        //    return billOffline(billslocal);
        //   })
          setIsOfflineBills(billsarray);
      })
      .catch(error => {
          console.error('Error getting bills:', error);
      });
    }
    
  },[isOnline])
  useEffect(() => {
    const fetchBills = async () => {
      if (isOnline && isOfflineBills) {
        try {
          // const billsarray = await getBillsFromIndexedDB();
          // console.log('Bills:', billsarray);
  
          for (const billslocal of isOfflineBills) {
            console.log('Fetching bill number for:', billslocal);
  
            const billNum = await getBillNumber(); // Wait for getBillNumber to resolve
            console.log('Fetched bill number:', billNum);
  
           await billOffline(billslocal, billNum);
          }
        } catch (error) {
          console.error('Error getting bills:', error);
        }
      }
    };
  
    fetchBills();
  }, [isOnline,isOfflineBills]);
  

  const updateOnlineStatus = () => {
    setIsOnline(navigator.onLine);
  };

  useEffect(() => {
    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);

    // Cleanup function to remove the event listeners when the component unmounts
    return () => {
      window.removeEventListener('online', updateOnlineStatus);
      window.removeEventListener('offline', updateOnlineStatus);
    };
  }, []);
  



  const getBill = async () => {
    let data = await getBillNumber();
    setbillNumber(data);
  };
 const billOffline =  (billslocal,billNum)=> {

  let companyCode = localStorage.getItem("companyCode");
  // let billCreated = localStorage.getItem("billCreated");
  let gst =
    localStorage.getItem("gst") &&
    localStorage.getItem("gst") != "undefined" &&
    localStorage.getItem("gst") != "disabled"
      ? localStorage.getItem("gst")
      : "";
  let gstType = localStorage.getItem("gstType") || "";
  // let saleType = RFTfeature() ? type : "";
  let billData = {
    company_code: localStorage.getItem("companyCode"),
    items: billslocal.items,
    date: billslocal.date,
    subTotal: billslocal.subTotal,
    discount: billslocal.discount,
    total: billslocal.total,
    billNumber: billNum,
    seller: localStorage.getItem("token"),
    customer: billslocal.customer,
    ledger_id:billslocal.ledger_id,
    change: parseInt(billslocal.change),
    paid: billslocal.paid,
    saleType:  billslocal.saleType,
    discount_type: billslocal.discount_type,
    notes: billslocal.notes,
    warehouseBill: templateType == "warehouse" ? true : false,
  };
  // if (companyCode == 9478 || companyCode == 1495) {
  //   billData.gst = gst;
  //   billData.gstType = gstType;
  // }
  console.log('billllldatatatat', billData)
  return BillsRepository.billsModel({
    request: {
      method: "saveBills",
      data: {
        bill: billData,
      },
    },
  }).then(response => {
    console.log('repsone', response)
    if (response.data.response.status.statusCode === 200) {
      // getBillNumber()
      getAllBills() 
      deleteBillFromIndexedDB(billslocal.id)
      .then(() => {
          console.log('Bill deleted successfully!');
      })
      .catch(error => {
          console.error('Error deleting bill:', error);
      });
    }
    return response
  })
  .catch(error => {
    console.error('Error saving bill:', error);
    throw error;
  });
 }
  const openToggle = (arg) => {
    setOpen((prev) => !prev);
    if (arg) {
      setSelectedBill({ date: arg.date, billNumber: arg.billNumber });
    } else {
      setSelectedBill({});
    }
  };

  const toggle = () => {
    setState((prev) => ({ ...prev, deleteModal: !prev.deleteModal }));
  };
  const getBillsWithPagination = async () => {
   
      try {
        // setLoading(true);
        let { data } = await Repo.bills({
          request: {
        method: "getStoreBillsWithPagination",
        data: {
            company_code: companyCode,
            next_page_token : ""
        }
          },
        });
        // setLoading(false);
        if (data.response.status.statusCode == 200) {
          setState((prev) => ({
            ...prev,
            outstandingBills: [
              // ...prev.outstandingBills,
              ...data.response.data.items,
            ],
            currentPageToken: data.response.data.current_page_token || "",
            nextPageToken: data.response.data.next_page_token || "",
          }));
        }
      } catch (err) {
        console.log("err:", err);
        // setLoading(false);
      }

  }
  const handleBillStatusChange = (event) => {
    console.log('event', event.target.value)
    if(event.target.value ===  "store") {
       getBillsWithPagination()
      setBillStatus(event.target.value);

    } else {
      setBillStatus(event.target.value);

    }
  };

  const getAllBills = (type = "") => {
    let token = type == "remove" ? "" : state.next_page_token;
    let outToken = type == "remove" ? "" : state.nextPageToken;
    setState((prev) => ({ ...prev, loading: true }));
    // " getOutstandings(outToken)]"
    Promise.all([getBills(token), getOutstandings(outToken)])
      .then((res) => {
        let allBills = res[0].data.response.data.items || [];
        let outBills = res[1].data.response.data.items || [];
        setState((pre) => ({
          ...pre,
          bills: allBills,
          next_page_token: res[0].data.response.data.next_page_token || "",
          current_page_token:
            res[0].data.response.data.current_page_token || "",
          outstandingBills: outBills,
          nextPageToken: res[1].data.response.data.next_page_token || "",
          currentPageToken: res[1].data.response.data.current_page_tokens || "",
          loading: false,
          hasMore: allBills && allBills.length < 20 ? false : true,
          more: outBills && outBills.length < 20 ? false : true,
        }));
      })
      .catch((err) => {
        console.log(err);
        setState((prev) => ({ ...prev, loading: false }));
      });
  };

  const loadBills = async () => {
    if (state.current_page_token && !state.next_page_token) {
      setState((prev) => ({
        ...prev,
        hasMore: !prev.hasMore,
      }));
    } else {
      let { data } = await BillsRepository.billsModel({
        request: {
          method: "getBillsWithPagination",
          data: {
            company_code: localStorage.getItem("companyCode"),
            next_page_token: state.next_page_token,
          },
        },
      });
      setState((prev) => ({
        ...prev,
        bills: [...prev.bills, ...data.response.data.items],
        current_page_token: data.response.data.current_page_token || "",
        next_page_token: data.response.data.next_page_token || "",
      }));
    }
  };
  const loadOutstandings = async () => {
    if (state.currentPageToken && !state.nextPageToken) {
      setState((prev) => ({
        ...prev,
        more: !prev.more,
      }));
    } else {
      let { data } = await BillsRepository.billsModel({
        request: {
          method: "getOutstandingBills",
          data: {
            company_code: localStorage.getItem("companyCode"),
            next_page_token: state.nextPageToken,
          },
        },
      });
      setState((prev) => ({
        ...prev,
        outstandingBills: [
          ...prev.outstandingBills,
          ...data.response.data.items,
        ],
        currentPageToken: data.response.data.current_page_token || "",
        nextPageToken: data.response.data.next_page_token || "",
      }));
    }
  };

  const billToggle = () => {
    setState((prev) => ({ ...prev, showBill: !prev.showBill }));
  };
  const SearchItems = async (first, second) => {
    setState((prev) => ({
      ...prev,
      loading: true,
    }));
    const { bills, out } = await getSearchBills(first, second, state.search);
    setState((prev) => ({
      ...prev,
      bills: bills,
      outstandingBills: out,
      hasMore: false,
      more: false,
      loading: false,
    }));
  };

  const shareToWhatsApp = (id) => {
            //  let newURL = `https://api.whatsapp.com/send?text=https://hardwarepakistan-7463e.web.app/inventory/bill-preview/${id}`; 
           let newURL = `https://api.whatsapp.com/send?text=https://managekaro.org/inventory/bill-preview/${id}`;  

    window.open(newURL, "_blank");
  };

  const handleChange = (e) => {
    const name = e.target.name;
    setState((prev) => ({ ...prev, [name]: !prev[name] }));
  };

  const handleSearch = (e) => {
    let value = e.target.value;
    setState((prev) => ({ ...prev, search: value, noBills: "" }));

    if (value == "") {
      setState((prev) => ({
        ...prev,
        bills: [],
        outstandingBills: [],
        hasMore: true,
        more: true,
      }));
      getAllBills();
    }
  };

  const clearFields = () => {
    setState((prev) => ({
      ...prev,
      search: "",
      startDate: "",
      endDate: "",
      bills: [],
      outstandingBills: [],
      hasMore: true,
      more: true,
    }));
    // getAllBills();
  };

  const submit = () => {
    if (state.search || (state.startDate && state.endDate)) {
      SearchItems();
    }
  };

  const handleDate = (type, e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (type == "start") {
      setState((prev) => ({ ...prev, [name]: value }));
      if (state.endDate) {
        SearchItems(value, state.endDate);
      }
    } else {
      setState((prev) => ({ ...prev, [name]: value }));
      if (state.startDate) {
        SearchItems(state.startDate, value);
      }
    }
  };

  const handleBill = (bill) => {
    setState((prev) => ({ ...prev, bill: bill, showBill: !prev.showBill }));
  };

  const handlePush = (bill, out = "") => {
    history.push({
      pathname: "/inventory/admin/bills/update-bill",
      state: {
        allbill: bill,
        bill: bill._id,
        out: out,
      },
    });
  };

  const removeBill = async () => {
    setState((prev) => ({
      ...prev,
      bills: [],
      outstandingBills: [],
      next_page_token: "",
      current_page_token: "",
      nextPageToken: "",
      currentPageToken: "",
      deleteModal: false,
      loading: true,
    }));
    await deleteBill(state.selectedBill);
    if(state.selectedBill.paymentMethod == "cash") {
      await deleteInCashInHand(state.selectedBill._id)

    } else if(state.selectedBill.paymentMethod == "bank") {
      await deleteInBank(state.selectedBill.bankId,state.selectedBill._id)

    }
    getAllBills("remove");
  };

  const handleDeleteBill = (bill) => {
    setState((prev) => ({ ...prev, deleteModal: true, selectedBill: bill }));
  };

  const onSuccess = () => {
    openToggle();
    getAllBills("remove");
  };

  return (
    <Box>
     
        {isMdDown ?
        <>
      <Grid sx={{ mt: 1 }} container spacing={2}>
        <Grid item lg={6} md={6} sm={12} xs={12}   >
          <SearchField>
            <TextField
              autoFocus
              size="small"
              fullWidth
              label=""
              name="search"
              value={state.search}
              type="text"
              placeholder="Search by Bill No. / Customer Name / Item "
              onChange={handleSearch}
              InputProps={{ disableUnderline: true }}
              onKeyDown={(e) => {
                if (e.key == "Enter") {
                  SearchItems();
                }
              }}
            />
            <Button size="small" onClick={submit}>
              <SearchIcon fontSize="small" />
            </Button>
          </SearchField>
        </Grid>
        <Grid item lg={6} md={6} sm={12} sx={{ width: { xs: '100%' } }}>
          <Grid container spacing={1}>
          <Grid item  sm={4} xs={4}>
          <p style={{ margin: "0px", padding: "0px" }}>Bill Status</p>
          <FormControl fullWidth size="small">
              <InputLabel id="bill-status-label">Select</InputLabel>
              <Select
                labelId="bill-status-label"
                id="bill-status"
                value={billStatus}
                label="Bill Status"
                onChange={handleBillStatusChange}
              >
                <MenuItem value="completed">Completed Bills</MenuItem>
                <MenuItem value="outstanding">Outstanding Bills</MenuItem>
              </Select>
            </FormControl>
            
         
      </Grid>
            <Grid item lg={5} md={5} sm={3} xs={3}>
              <p style={{ margin: "0px", padding: "0px" }}>Start Date</p>
              <DateField
                fullWidth
                size="small"
                type="date"
                name="startDate"
                value={state.startDate}
                variant="outlined"
                onChange={(e) => handleDate("start", e)}
              />
            </Grid>
            <Grid item lg={5} md={5} sm={3} xs={3}>
              <p style={{ margin: "0px", padding: "0px" }}>End Date</p>
              <DateField
                fullWidth
                size="small"
                type="date"
                name="endDate"
                variant="outlined"
                value={state.endDate}
                onChange={(e) => handleDate("end", e)}
              />
            </Grid>
            <Grid item lg={2} md={2} sm={2} xs={2}>
              <ButtonClear size="small" onClick={clearFields}>
                Clear
              </ButtonClear>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container justifyContent="flex-end">
      <FormControlLabel
          control={
            <Checkbox
              name="profit"
               checked={state.profit}
               onChange={handleChange}
            />
          }
          label="Profit"
        />
      </Grid>
  <Grid container>
    {billStatus == "completed" ? 
        <Grid item lg={6} md={6} sm={12}>
         {companyCode != 6915  ? <Title variant="h5" sx={{ fontSize: { md: "1.5rem", xs: "16px" } }}> 
            Bills
          </Title>
          :  
          <Title variant="h5" sx={{ fontSize: { md: "1.5rem", xs: "16px" } }}> 
            Delivered Bills
          </Title>
        }
          <InfiniteScroll
            dataLength={state?.bills?.length}
            next={loadBills}
            hasMore={state.hasMore}
            loader={<h2 align="center">Loading...</h2>}
            endMessage={
              <h2 style={{ textAlign: "center" }}>
                <b>No More Bills</b>
              </h2>
            }
          >
            {state.noBills && state.bills.length == 0 && (
              <h2 style={{ textAlign: "center" }}>
                <b>{state.noBills}</b>
              </h2>
            )}
     
            {/* billsData.map */}
            {state?.bills?.map((bill, index) => {
              return (
                <BillBox key={index}>
                  <Grid item xs={11}>
                    <Grid container>
                      <Grid item md={4} xs={12}>
                        <Grid container>
                          <Grid item md={5} xs={12}>
                            <img
                              src={billImg}
                              className="item-img "
                              style={{ marginRight: "10px" }}
                              onClick={() => handleBill(bill)}
                            />
                          </Grid>

                          <Grid item md={7} xs={12}>
                            <TitleBox>
                              <Typography
                                sx={{
                                  fontWeight: { md: "bold", xs: "400" },
                                  color: "#757575",
                                }}
                              >
                                Bill #
                              </Typography>
                              <Typography sx={{ color: "#4EAf51" }}>
                                {bill?.billNumber}
                              </Typography>
                            </TitleBox>
                          </Grid>

                          <Grid item xs={12}>
                            <Typography
                              sx={{
                                fontWeight: "bold",
                                color: "#757575",
                                cursor: "pointer",
                              }}
                              onClick={() => openToggle(bill)}
                            >
                              {moment
                                .unix(bill?.created_at)
                                .format("DD-MM-YYYY")}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid item md={2.7} xs={12}>
                        <TitleBox>
                          <Typography
                            sx={{
                              fontWeight: { md: "bold", xs: "400" },
                              color: "#757575",
                            }}
                          >
                            Amount
                          </Typography>
                          <Typography sx={{ color: "#4EAf51" }}>
                            {parseInt(bill?.total) || 0}
                          </Typography>
                        </TitleBox>
                        <TitleBox>
                          <Typography
                            sx={{
                              fontWeight: { md: "bold", xs: "400" },
                              color: "#757575",
                            }}
                          >
                            Profit
                          </Typography>
                          <Typography sx={{ color: "#4EAf51" }}>
                            {bill?.profit}
                          </Typography>
                        </TitleBox>
                        
                      </Grid>
                      <Grid item md={5.3} xs={12}>
                        <TitleBox>
                          <Typography
                            sx={{
                              fontWeight: { md: "bold", xs: "400" },
                              color: "#757575",
                            }}
                          >
                            Customer
                          </Typography>
                          <Typography sx={{ color: "#4EAf51" }}>
                            {bill?.customer}
                          </Typography>
                        </TitleBox>
                        <TitleBox>
                          <Typography
                            sx={{
                              fontWeight: { md: "bold", xs: "400" },
                              color: "#757575",
                            }}
                          >
                            Employee
                          </Typography>
                          <Typography
                            sx={{ fontSize: "13px", color: "#4EAf51" }}
                            className="email-overflow"
                          >
                            {bill?.seller}
                          </Typography>
                        </TitleBox>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={1} height="100%">
                    <IconBox>
                      <img
                        onClick={() => shareToWhatsApp(bill._id)}
                        height="25px"
                        width="25px"
                        src={whatsAppIcon}
                        alt=""
                        style={{ cursor: "pointer" }}
                      />
                      <i
                        style={{
                          fontSize: "23px",
                          cursor: "pointer",
                          color: "#757575",
                        }}
                        className="fas fa-edit"
                        onClick={() => handlePush(bill)}
                      />
                      {localStorage.getItem("tokenType") == "admin" && (
                        <img
                          style={{ cursor: "pointer" }}
                          height="25px"
                          src={dustbin}
                          alt=""
                          onClick={() => handleDeleteBill(bill)}
                        />
                      )}
                    </IconBox>
                  </Grid>
                </BillBox>
              );
            })}
          </InfiniteScroll>
        </Grid>
        :
        <Grid item lg={6} md={6} sm={12}>
        {companyCode != 6915  ?  <Title variant="h5" sx={{ fontSize: { md: "1.5rem", xs: "16px" } }}>
            Outstanding Bills
          </Title> 
          :
          <Title variant="h5" sx={{ fontSize: { md: "1.5rem", xs: "16px" } }}>
            Pending Bills
          </Title>
           }
          <InfiniteScroll
            dataLength={state.outstandingBills.length}
            next={loadOutstandings}
            hasMore={state.more}
            loader={<h2 align="center">Loading...</h2>}
            endMessage={
              <h2 style={{ textAlign: "center" }}>
                <b>No More Outstanding Bills</b>
              </h2>
            }
          >
            {state.noBills && state.outstandingBills.length == 0 && (
              <h2 style={{ textAlign: "center" }}>
                <b>{state.noBills}</b>
              </h2>
            )}
            {state.outstandingBills.map((bill, index) => {
              return (
                <BillBox key={index}>
                  <Grid item xs={11}>
                    <Grid container>
                      <Grid item md={4} xs={12}>
                        <Grid container>
                          <Grid item md={5} xs={12}>
                            <img
                              src={billImg}
                              className="item-img"
                              style={{ marginRight: "10px" }}
                              onClick={() => handleBill(bill)}
                            />
                          </Grid>

                          <Grid item md={7} xs={12}>
                            <TitleBox>
                              <Typography
                                sx={{
                                  fontWeight: { md: "bold", xs: "400" },
                                  color: "#757575",
                                }}
                              >
                                Bill #
                              </Typography>
                              <Typography sx={{ color: "#4EAf51" }}>
                                {bill?.billNumber}
                              </Typography>
                            </TitleBox>
                          </Grid>

                          <Grid item xs={12}>
                            <Typography
                              sx={{
                                fontWeight: "bold",
                                color: "#757575",
                                cursor: "pointer",
                              }}
                              onClick={() => openToggle(bill)}
                            >
                              {moment
                                .unix(bill?.created_at)
                                .format("DD-MM-YYYY")}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid item md={2.7} xs={12}>
                        <TitleBox>
                          <Typography
                            sx={{
                              fontWeight: { md: "bold", xs: "400" },
                              color: "#757575",
                            }}
                          >
                            Amount
                          </Typography>
                          <Typography sx={{ color: "#4EAf51" }}>
                            {parseInt(bill?.total) || 0}
                          </Typography>
                        </TitleBox>
                        <TitleBox>
                          <Typography
                            sx={{
                              fontWeight: { md: "bold", xs: "400" },
                              color: "#757575",
                            }}
                          >
                            Profit
                          </Typography>
                          <Typography sx={{ color: "#4EAf51" }}>
                            {bill?.profit}
                          </Typography>
                        </TitleBox>
                        {state.profit && (
                            <TitleBox>
                            <Typography
                              sx={{
                                fontWeight: { md: "bold", xs: "400" },
                                color: "#757575",
                              }}
                            >
                             Credit Profit
                            </Typography>
                            <Typography sx={{ color: "#4EAf51" }}>
                              {bill?.creditProfit}
                            </Typography>
                          </TitleBox>
                        )}
                      </Grid>
                      <Grid item md={5.3} xs={12}>
                        <TitleBox>
                          <Typography
                            sx={{
                              fontWeight: { md: "bold", xs: "400" },
                              color: "#757575",
                            }}
                          >
                            Customer
                          </Typography>
                          <Typography sx={{ color: "#4EAf51" }}>
                            {bill?.customer}
                          </Typography>
                        </TitleBox>
                        <TitleBox>
                          <Typography
                            sx={{
                              fontWeight: { md: "bold", xs: "400" },
                              color: "#757575",
                            }}
                          >
                            Employee
                          </Typography>
                          <Typography
                            className="email-overflow"
                            sx={{ fontSize: "13px", color: "#4EAf51" }}
                          >
                            {bill?.seller}
                          </Typography>
                        </TitleBox>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={1} height="100%">
                    <IconBox>
                      <img
                        onClick={() => shareToWhatsApp(bill._id)}
                        height="25px"
                        width="25px"
                        src={whatsAppIcon}
                        alt=""
                        style={{ cursor: "pointer" }}
                      />
                      <i
                        style={{
                          fontSize: "23px",
                          cursor: "pointer",
                          color: "#757575",
                        }}
                        className="fas fa-edit"
                        onClick={() => handlePush(bill)}
                      />
                      {localStorage.getItem("tokenType") == "admin" && (
                        <img
                          style={{ cursor: "pointer" }}
                          height="25px"
                          src={dustbin}
                          alt=""
                          onClick={() => handleDeleteBill(bill)}
                        />
                      )}
                    </IconBox>
                  </Grid>
                </BillBox>
              );
            })}
          </InfiniteScroll>
        </Grid> }
      </Grid>
      </>
: 
<>
<Grid sx={{ mt: 1 }} container spacing={2}>
        <Grid item lg={6} md={6} sm={12} xs={12}>
          <SearchField>
            <TextField
              autoFocus
              size="small"
              fullWidth
              label=""
              name="search"
              value={state.search}
              type="text"
              placeholder="Search by Bill No. / Customer Name / Item "
              onChange={handleSearch}
              InputProps={{ disableUnderline: true }}
              onKeyDown={(e) => {
                if (e.key == "Enter") {
                  SearchItems();
                }
              }}
            />
            <Button size="small" onClick={submit}>
              <SearchIcon fontSize="small" />
            </Button>
          </SearchField>
        </Grid>
   
      
        <Grid item lg={6} md={6} sm={12}>
          <Grid container spacing={1}>
            <Grid item lg={5} md={5} sm={5} xs={5}>
              <p style={{ margin: "0px", padding: "0px" }}>Start Date</p>
              <DateField
                fullWidth
                size="small"
                type="date"
                name="startDate"
                value={state.startDate}
                variant="outlined"
                onChange={(e) => handleDate("start", e)}
              />
            </Grid>
            <Grid item lg={5} md={5} sm={5} xs={5}>
              <p style={{ margin: "0px", padding: "0px" }}>End Date</p>
              <DateField
                fullWidth
                size="small"
                type="date"
                name="endDate"
                variant="outlined"
                value={state.endDate}
                onChange={(e) => handleDate("end", e)}
              />
            </Grid>
            <Grid item lg={2} md={2} sm={2} xs={2}>
              <ButtonClear size="small" onClick={clearFields}>
                Clear
              </ButtonClear>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid container justifyContent="flex-end">
      <FormControlLabel
          control={
            <Checkbox
              name="profit"
               checked={state.profit}
               onChange={handleChange}
            />
          }
          label="Profit"
        />
      </Grid>
      <Grid container spacing={1}>

      <Grid item lg={3} md={3} sm={12}>

      {( companyCode == "2099"|| companyCode == "3388" ) ? 
       <FormControl fullWidth size="small">
       <InputLabel id="bill-status-label">Select</InputLabel>
       <Select
         labelId="bill-status-label"
         id="bill-status"
         value={billStatus}
         label="Bills Category"
         onChange={handleBillStatusChange}
       >
         <MenuItem value="simple">Simple Bills</MenuItem>
         <MenuItem value="store">Store Bills</MenuItem>
       </Select>
     </FormControl> : ""}
     </Grid>
     </Grid>
<Grid container>
{billStatus == "store" ? 

   <Grid item lg={6} md={6} sm={12}>
         {companyCode != 6915  ? <Title variant="h5" sx={{ fontSize: { md: "1.5rem", xs: "16px" } }}> 
            Store Bills
          </Title>
          :  
          <Title variant="h5" sx={{ fontSize: { md: "1.5rem", xs: "16px" } }}> 
            Delivered Bills
          </Title>
        }
          <InfiniteScroll
            dataLength={state?.bills?.length}
            next={loadBills}
            hasMore={state.hasMore}
            loader={<h2 align="center">Loading...</h2>}
            endMessage={
              <h2 style={{ textAlign: "center" }}>
                <b>No More Bills</b>
              </h2>
            }
          >
            {state.noBills && state.bills.length == 0 && (
              <h2 style={{ textAlign: "center" }}>
                <b>{state.noBills}</b>
              </h2>
            )}
            {/* billsData.map */}
            {state?.outstandingBills?.map((bill, index) => {
              return (
                <BillBox key={index}>
                  <Grid item xs={11}>
                    <Grid container>
                      <Grid item md={4} xs={12}>
                        <Grid container>
                          <Grid item md={5} xs={12}>
                            <img
                              src={billImg}
                              className="item-img "
                              style={{ marginRight: "10px" }}
                              onClick={() => handleBill(bill)}
                            />
                          </Grid>

                          <Grid item md={7} xs={12}>
                            <TitleBox>
                              <Typography
                                sx={{
                                  fontWeight: { md: "bold", xs: "400" },
                                  color: "#757575",
                                }}
                              >
                                Bill #
                              </Typography>
                              <Typography sx={{ color: "#4EAf51" }}>
                                {bill?.billNumber}
                              </Typography>
                            </TitleBox>
                          </Grid>

                          <Grid item xs={12}>
                            <Typography
                              sx={{
                                fontWeight: "bold",
                                color: "#757575",
                                cursor: "pointer",
                              }}
                              onClick={() => openToggle(bill)}
                            >
                              {moment
                                .unix(bill?.created_at)
                                .format("DD-MM-YYYY")}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid item md={2.7} xs={12}>
                        <TitleBox>
                          <Typography
                            sx={{
                              fontWeight: { md: "bold", xs: "400" },
                              color: "#757575",
                            }}
                          >
                            Amount
                          </Typography>
                          <Typography sx={{ color: "#4EAf51" }}>
                            {parseInt(bill?.total) || 0}
                          </Typography>
                        </TitleBox>
                        <TitleBox>
                          <Typography
                            sx={{
                              fontWeight: { md: "bold", xs: "400" },
                              color: "#757575",
                            }}
                          >
                            Profit
                          </Typography>
                          <Typography sx={{ color: "#4EAf51" }}>
                            {bill?.profit}
                          </Typography>
                        </TitleBox>
                        
                      </Grid>
                      <Grid item md={5.3} xs={12}>
                        <TitleBox>
                          <Typography
                            sx={{
                              fontWeight: { md: "bold", xs: "400" },
                              color: "#757575",
                            }}
                          >
                            Customer
                          </Typography>
                          <Typography sx={{ color: "#4EAf51" }}>
                            {bill?.customer}
                          </Typography>
                        </TitleBox>
                        <TitleBox>
                          <Typography
                            sx={{
                              fontWeight: { md: "bold", xs: "400" },
                              color: "#757575",
                            }}
                          >
                            Employee
                          </Typography>
                          <Typography
                            sx={{ fontSize: "13px", color: "#4EAf51" }}
                            className="email-overflow"
                          >
                            {bill?.seller}
                          </Typography>
                        </TitleBox>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={1} height="100%">
                    <IconBox>
                      <img
                        onClick={() => shareToWhatsApp(bill._id)}
                        height="25px"
                        width="25px"
                        src={whatsAppIcon}
                        alt=""
                        style={{ cursor: "pointer" }}
                      />
                      <i
                        style={{
                          fontSize: "23px",
                          cursor: "pointer",
                          color: "#757575",
                        }}
                        className="fas fa-edit"
                        onClick={() => handlePush(bill)}
                      />
                      {localStorage.getItem("tokenType") == "admin" && (
                        <img
                          style={{ cursor: "pointer" }}
                          height="25px"
                          src={dustbin}
                          alt=""
                          onClick={() => handleDeleteBill(bill)}
                        />
                      )}
                    </IconBox>
                  </Grid>
                </BillBox>
              );
            })}
          </InfiniteScroll>
        </Grid>






 :










<>
<Grid item lg={6} md={6} sm={12}>
 {companyCode != 6915  ? <Title variant="h5" sx={{ fontSize: { md: "1.5rem", xs: "16px" } }}> 
    Bills
  </Title>
  :  
  <Title variant="h5" sx={{ fontSize: { md: "1.5rem", xs: "16px" } }}> 
    Delivered Bills
  </Title>
}
  {/* <InfiniteScroll
    dataLength={state?.bills?.length}
    next={loadBills}
    hasMore={state.hasMore}
    loader={<h2 align="center">Loading...</h2>}
    endMessage={
      <h2 style={{ textAlign: "center" }}>
        <b>No More Bills</b>
      </h2>
    }
  > */}
    {state.noBills && state.bills.length == 0 && (
      <h2 style={{ textAlign: "center" }}>
        <b>{state.noBills}</b>
      </h2>
    )}
    {/* billsData.map */}
    {state?.bills?.map((bill, index) => {
              return (
                <BillBox key={index}>
                  <Grid item xs={11}>
                    <Grid container>
                      <Grid item md={4} xs={12}>
                        <Grid container>
                          <Grid item md={5} xs={12}>
                            <img
                              src={billImg}
                              className="item-img "
                              style={{ marginRight: "10px" }}
                              onClick={() => handleBill(bill)}
                            />
                          </Grid>

                          <Grid item md={7} xs={12}>
                            <TitleBox>
                              <Typography
                                sx={{
                                  fontWeight: { md: "bold", xs: "400" },
                                  color: "#757575",
                                }}
                              >
                                Bill #
                              </Typography>
                              <Typography sx={{ color: "#4EAf51" }}>
                                {bill?.billNumber}
                              </Typography>
                            </TitleBox>
                          </Grid>

                          <Grid item xs={12}>
                            <Typography
                              sx={{
                                fontWeight: "bold",
                                color: "#757575",
                                cursor: "pointer",
                              }}
                              onClick={() => openToggle(bill)}
                            >
                              {moment
                                .unix(bill?.created_at)
                                .format("DD-MM-YYYY")}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid item md={2.7} xs={12}>
                        <TitleBox>
                          <Typography
                            sx={{
                              fontWeight: { md: "bold", xs: "400" },
                              color: "#757575",
                            }}
                          >
                            Amount
                          </Typography>
                          <Typography sx={{ color: "#4EAf51" }}>
                            {parseInt(bill?.total) || 0}
                          </Typography>
                        </TitleBox>
                        <TitleBox>
                          <Typography
                            sx={{
                              fontWeight: { md: "bold", xs: "400" },
                              color: "#757575",
                            }}
                          >
                            Profit
                          </Typography>
                          <Typography sx={{ color: "#4EAf51" }}>
                            {bill?.profit}
                          </Typography>
                        </TitleBox>
                        {/* {state.profit && (
                            <TitleBox>
                            <Typography
                              sx={{
                                fontWeight: { md: "bold", xs: "400" },
                                color: "#757575",
                              }}
                            >
                              Profit
                            </Typography>
                            <Typography sx={{ color: "#4EAf51" }}>
                              {bill?.profit}
                            </Typography>
                          </TitleBox>
                        )} */}
                    
                      </Grid>
                      <Grid item md={5.3} xs={12}>
                        <TitleBox>
                          <Typography
                            sx={{
                              fontWeight: { md: "bold", xs: "400" },
                              color: "#757575",
                            }}
                          >
                            Customer
                          </Typography>
                          <Typography sx={{ color: "#4EAf51" }}>
                            {bill?.customer}
                          </Typography>
                        </TitleBox>
                        <TitleBox>
                          <Typography
                            sx={{
                              fontWeight: { md: "bold", xs: "400" },
                              color: "#757575",
                            }}
                          >
                            Employee
                          </Typography>
                          <Typography
                            sx={{ fontSize: "13px", color: "#4EAf51" }}
                            className="email-overflow"
                          >
                            {bill?.seller}
                          </Typography>
                        </TitleBox>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={1} height="100%">
                    <IconBox>
                      <img
                        onClick={() => shareToWhatsApp(bill._id)}
                        height="25px"
                        width="25px"
                        src={whatsAppIcon}
                        alt=""
                        style={{ cursor: "pointer" }}
                      />
                      <i
                        style={{
                          fontSize: "23px",
                          cursor: "pointer",
                          color: "#757575",
                        }}
                        className="fas fa-edit"
                        onClick={() => handlePush(bill)}
                      />
                      {localStorage.getItem("tokenType") == "admin" && (
                        <img
                          style={{ cursor: "pointer" }}
                          height="25px"
                          src={dustbin}
                          alt=""
                          onClick={() => handleDeleteBill(bill)}
                        />
                      )}
                    </IconBox>
                  </Grid>
                </BillBox>
              );
            })}
    {/* </InfiniteScroll> */}
</Grid>
<Grid item lg={6} md={6} sm={12}>
{companyCode != 6915  ?  <Title variant="h5" sx={{ fontSize: { md: "1.5rem", xs: "16px" } }}>
    Outstanding Bills
  </Title> 
  :
  <Title variant="h5" sx={{ fontSize: { md: "1.5rem", xs: "16px" } }}>
    Pending Bills
  </Title>
   }
  <InfiniteScroll
    dataLength={state.outstandingBills.length}
    next={loadOutstandings}
    hasMore={state.more}
    loader={<h2 align="center">Loading...</h2>}
    endMessage={
      <h2 style={{ textAlign: "center" }}>
        <b>No More Outstanding Bills</b>
      </h2>
    }
  >
    {state.noBills && state.outstandingBills.length == 0 && (
      <h2 style={{ textAlign: "center" }}>
        <b>{state.noBills}</b>
      </h2>
    )}
    {state.outstandingBills.map((bill, index) => {
      return (
        <BillBox key={index}>
          <Grid item xs={11}>
            <Grid container>
              <Grid item md={4} xs={12}>
                <Grid container>
                  <Grid item md={5} xs={12}>
                    <img
                      src={billImg}
                      className="item-img"
                      style={{ marginRight: "10px" }}
                      onClick={() => handleBill(bill)}
                    />
                  </Grid>

                  <Grid item md={7} xs={12}>
                    <TitleBox>
                      <Typography
                        sx={{
                          fontWeight: { md: "bold", xs: "400" },
                          color: "#757575",
                        }}
                      >
                        Bill #
                      </Typography>
                      <Typography sx={{ color: "#4EAf51" }}>
                        {bill?.billNumber}
                      </Typography>
                    </TitleBox>
                  </Grid>

                  <Grid item xs={12}>
                    <Typography
                      sx={{
                        fontWeight: "bold",
                        color: "#757575",
                        cursor: "pointer",
                      }}
                      onClick={() => openToggle(bill)}
                    >
                      {moment
                        .unix(bill?.created_at)
                        .format("DD-MM-YYYY")}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item md={2.7} xs={12}>
                <TitleBox>
                  <Typography
                    sx={{
                      fontWeight: { md: "bold", xs: "400" },
                      color: "#757575",
                    }}
                  >
                    Amount
                  </Typography>
                  <Typography sx={{ color: "#4EAf51" }}>
                    {parseInt(bill?.total) || 0}
                  </Typography>
                </TitleBox>
                <TitleBox>
                  <Typography
                    sx={{
                      fontWeight: { md: "bold", xs: "400" },
                      color: "#757575",
                    }}
                  >
                    Profit
                  </Typography>
                  <Typography sx={{ color: "#4EAf51" }}>
                    {bill?.profit}
                  </Typography>
                </TitleBox>
                {state.profit && (
                            <TitleBox>
                            <Typography
                              sx={{
                                fontWeight: { md: "bold", xs: "400" },
                                color: "#757575",
                              }}
                            >
                             Credit Profit
                            </Typography>
                            <Typography sx={{ color: "#4EAf51" }}>
                              {bill?.creditProfit}
                            </Typography>
                          </TitleBox>
                        )}
              </Grid>
              <Grid item md={5.3} xs={12}>
                <TitleBox>
                  <Typography
                    sx={{
                      fontWeight: { md: "bold", xs: "400" },
                      color: "#757575",
                    }}
                  >
                    Customer
                  </Typography>
                  <Typography sx={{ color: "#4EAf51" }}>
                    {bill?.customer}
                  </Typography>
                </TitleBox>
                <TitleBox>
                  <Typography
                    sx={{
                      fontWeight: { md: "bold", xs: "400" },
                      color: "#757575",
                    }}
                  >
                    Employee
                  </Typography>
                  <Typography
                    className="email-overflow"
                    sx={{ fontSize: "13px", color: "#4EAf51" }}
                  >
                    {bill?.seller}
                  </Typography>
                </TitleBox>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={1} height="100%">
            <IconBox>
              <img
                onClick={() => shareToWhatsApp(bill._id)}
                height="25px"
                width="25px"
                src={whatsAppIcon}
                alt=""
                style={{ cursor: "pointer" }}
              />
              <i
                style={{
                  fontSize: "23px",
                  cursor: "pointer",
                  color: "#757575",
                }}
                className="fas fa-edit"
                onClick={() => handlePush(bill)}
              />
              {localStorage.getItem("tokenType") == "admin" && (
                <img
                  style={{ cursor: "pointer" }}
                  height="25px"
                  src={dustbin}
                  alt=""
                  onClick={() => handleDeleteBill(bill)}
                />
              )}
            </IconBox>
          </Grid>
        </BillBox>
      );
    })}
  </InfiniteScroll>
</Grid>
</>
}
</Grid>
  
</>
}
            

      <BillPreview
        title="Bill Preview"
        open={state.showBill}
        onClose={billToggle}
        onClickCancel={billToggle}
        bill={state.bill}
      />

      {open && (
        <UpdateBillDate
          bill={selectedBill}
          onClose={openToggle}
          onSuccess={onSuccess}
        />
      )}

      <DeleteBill
        title="Delete Bill"
        open={state.deleteModal}
        onClose={toggle}
        onClickYes={removeBill}
        onClickCancel={toggle}
      />
      <Stack alignItems="center">
        <ClipLoader size={50} color="#4DAF51" loading={state.loading} />
      </Stack>
    </Box>
  );
}
export default Bills;
